interface TooltipEntry {
  name?: string | number;
  value?: string | number;
  color?: string;
}

interface ChartTooltipProps {
  active?: boolean;
  payload?: TooltipEntry[];
  label?: string | number;
  formatValue?: (value: number, name: string) => string;
}

export function ChartTooltip({ active, payload, label, formatValue }: ChartTooltipProps) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 py-2 text-xs shadow-lg">
      <p className="mb-1.5 font-medium text-gray-700 dark:text-gray-200">{String(label ?? '')}</p>
      {payload.map((entry, i) => {
        const name = String(entry.name ?? '');
        const value = Number(entry.value ?? 0);
        return (
          <div key={i} className="flex items-center justify-between gap-4">
            <span className="flex items-center gap-1.5 text-gray-500 dark:text-gray-300">
              <span
                className="inline-block h-2 w-2 rounded-full"
                style={{ background: entry.color ?? '#888' }}
              />
              {name}
            </span>
            <span className="font-semibold tabular-nums text-gray-800 dark:text-white">
              {formatValue ? formatValue(value, name) : value.toLocaleString()}
            </span>
          </div>
        );
      })}
    </div>
  );
}
